import { render, staticRenderFns } from "./pageSidebarHelp.vue?vue&type=template&id=04fcaf86&scoped=true"
import script from "./pageSidebarHelp.vue?vue&type=script&lang=js"
export * from "./pageSidebarHelp.vue?vue&type=script&lang=js"
import style0 from "./pageSidebarHelp.vue?vue&type=style&index=0&id=04fcaf86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fcaf86",
  null
  
)

export default component.exports